import { render, staticRenderFns } from "./ContactNetworkItem.vue?vue&type=template&id=3fc890de&scoped=true&"
import script from "./ContactNetworkItem.vue?vue&type=script&lang=js&"
export * from "./ContactNetworkItem.vue?vue&type=script&lang=js&"
import style0 from "./ContactNetworkItem.vue?vue&type=style&index=0&id=3fc890de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc890de",
  null
  
)

export default component.exports